module.exports = __webpack_public_path__ + "static/media/AK_7.3a34ea13.jpeg";